// Consultor a ver um processo já com a gestão processual: «a Marta trata» (só informação, sem botões).
export const gpTrata = (p) => (p?.gestao?.viewer === "consultor" ? `${p.gestao.art || "a"} ${p.gestao.first} trata` : null);

// Só as tarefas que são mesmo do consultor (a lista «Com a gestão processual» não aparece).
export const mineOnly = (p) => {
  const at = p.a_tratar || {};
  return { ...p, a_tratar: { ...at, lines: (at.lines || []).filter((ln) => ln.dono === "consultor"), groups: (at.groups || []).filter((g) => g.key === "consultor") } };
};
